<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true" size="small">
      <el-tab-pane label="设备详情" name="first">
        <el-descriptions title="智能漏损定位终端" direction="vertical" :column="2" border>
          <el-descriptions-item label="设备串号">
            <el-tag>{{ press.DeviceIMEI }}</el-tag>
          </el-descriptions-item>
          <!--          <el-descriptions-item label="采集时间">-->
          <!--            <el-tag size="small">{{ tacq }}</el-tag>-->
          <!--          </el-descriptions-item>-->
          <el-descriptions-item label="阀门状态">
            <el-tag type="success" size="small" v-if="press.ValvStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.ValvStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="数据状态">
            <el-tag type="success" size="small" v-if="press.Status===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.Status===2">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="水压状态">
            <el-tag type="success" size="small" v-if="press.WaterStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.WaterStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="撞到状态">
            <el-tag type="success" size="small" v-if="press.KnockDownStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.KnockDownStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="敲击状态">
            <el-tag type="success" size="small" v-if="press.KnockStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.KnockStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="盒体状态">
            <el-tag type="success" size="small" v-if="press.SeparationStatus===0">正常</el-tag>
            <el-tag type="danger" size="small" v-if="press.SeparationStatus===1">警告</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="电压">
            <el-tag size="small">{{ press.Voltage }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="温度">{{ press.Temperature }}</el-descriptions-item>
          <el-descriptions-item label="水压"> {{ press.Water }}</el-descriptions-item>
          <el-descriptions-item label="采集次数"> {{ press.SendNumber }}</el-descriptions-item>
         <el-descriptions-item label="安装位置"> {{ press.address }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>
  </div>


</template>

<script>
import axios from "axios";

export default {
  name: "Press",
  data() {
    return {
      activeName: "first",
      press: {
        DeviceIMEI: '',
        address: '',
        tacq: '',
        Status: '',
        WaterStatus: '',
        ValvStatus: '',
        KnockDownStatus: '',
        KnockStatus: '',
        SeparationStatus: '',
        Voltage: '',
        Temperature: '',
        Water: '',
        DeviceSignal: '',
        SendNumber: '',
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const imei = this.$route.query.imei
      axios.get("/api1/press/yun/" + imei).then((res => {
        this.press = res.data.data
      }))
    }
  }
}
</script>

<style scoped>
/deep/ .el-descriptions-item__cell{
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contract/Press_v1.vue